import React from 'react';
import { Layout, Button, Dropdown, Avatar, Space, Input, theme as antTheme } from 'antd';
import {
  UserOutlined,
  SettingOutlined,
  LogoutOutlined,
  MoonOutlined,
  SunOutlined,
  SearchOutlined,
  FullscreenOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useThemeStore } from '@stores/themeStore';
import { useAuthStore } from '@stores/authStore';
import { NotificationDropdown } from '@components/notification/NotificationDropdown';

const { Header: AntHeader } = Layout;
const { useToken } = antTheme;

export const Header: React.FC = () => {
  const navigate = useNavigate();
  const { token } = useToken();
  const { isDark, toggleTheme } = useThemeStore();
  const { logout, user } = useAuthStore();

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人中心',
      onClick: () => navigate('/profile'),
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: '系统设置',
      onClick: () => navigate('/settings'),
    },
    { type: 'divider' as const },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: logout,
    },
  ];

  return (
    <AntHeader
      className="flex items-center justify-between px-6 bg-white dark:bg-gray-900 shadow-sm"
      style={{ background: token.colorBgContainer }}
    >
      {/* 左侧：面包屑/搜索 */}
      <div className="flex items-center gap-4">
        <Input
          placeholder="搜索项目、任务、成员..."
          prefix={<SearchOutlined />}
          className="w-80"
          allowClear
        />
      </div>

      {/* 右侧：操作按钮 */}
      <Space size={16}>
        {/* 主题切换 */}
        <Button
          type="text"
          icon={isDark ? <SunOutlined /> : <MoonOutlined />}
          onClick={toggleTheme}
        />

        {/* 全屏 */}
        <Button
          type="text"
          icon={<FullscreenOutlined />}
          onClick={() => {
            if (!document.fullscreenElement) {
              document.documentElement.requestFullscreen();
            } else {
              document.exitFullscreen();
            }
          }}
        />

        {/* 通知 */}
        <NotificationDropdown />

        {/* 用户菜单 */}
        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <Space className="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 px-3 py-1 rounded">
            <Avatar icon={<UserOutlined />} src={user?.avatar} />
            <span className="hidden md:inline">{user?.name || '管理员'}</span>
          </Space>
        </Dropdown>
      </Space>
    </AntHeader>
  );
};
